<template>
  <base-dialog
    class="modal-category"
    :title="$t('category.editTitle')"
    :openDialog="openEditDialog"
  >
    <el-form
      :model="form"
      ref="form"
      label-position="top"
      :rules="validator"
      @submit.native.prevent
    >
      <el-row :gutter="50" class="row-input">
        <el-col :span="24">
          <el-form-item :label="$t('category.name')" prop="name">
            <el-input
              class="input"
              v-model="form.name"
              autocomplete="off"
              id="masterDataInput"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="form.name = ''"
                v-if="form.name"
              ></i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <span class="dialog-footer">
          <el-button class="btn btn--cancel" @click="handleCloseEditDialog()">
            {{ $t('employee.cancelBtn') }}
          </el-button>
          <el-button
            class="btn btn--submit"
            :disabled="editSubcategoryLoading"
            @click="onSubmit('form')"
          >
            {{ $t('category.editBtn') }}
          </el-button>
        </span>
      </el-form-item>
    </el-form>
  </base-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { subcategoryService } from '@/services/subcategory.service';
import { handleError, notifyMessage } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import { maxName225 } from '@/helper/validate';

const BaseDialog = () => import('@/components/Dialog');

export default {
  components: { BaseDialog },
  props: {
    openEditDialog: Boolean,
    subcategorySelected: Object,
  },
  data() {
    return {
      editSubcategoryLoading: false,
      form: {
        name: this.subcategorySelected ? this.subcategorySelected.name : '',
      },
      validator: {
        name: [{ validator: maxName225, trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters('subcategory', ['subcategory']),
  },
  watch: {
    subcategorySelected() {
      this.form.name = this.subcategorySelected.name;
    },
    'form.name'() {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate('name');
      }
    },
  },
  updated() {
    let inputelement = document.getElementById('masterDataInput');
    if (inputelement) {
      inputelement.focus();
    }
  },
  methods: {
    ...mapActions('subcategory', ['getSubcategoryList']),
    handleCloseEditDialog() {
      this.$emit('handleCloseEditDialog');
    },
    onSubmit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          this.editSubcategoryLoading = true;

          return await subcategoryService
            .edit(this.subcategorySelected.id, {
              name: this.form.name.trim(),
            })
            .then(() => {
              this.getSubcategoryList({
                categoryId: this.$router.currentRoute.params.id,
                params: {
                  name: this.$route.query.name,
                  page: this.$route.query.page || PAGE,
                  limit: LIMIT,
                },
              });
              this.$emit('handleCloseEditDialog');
              this.$refs[form].resetFields();
              notifyMessage(this.$t('common.editSuccess'), 'success');
            })
            .catch((error) => {
              handleError(error);
            })
            .finally(() => {
              this.editSubcategoryLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.modal-category {
  .el-input {
    input {
      height: 47px;
    }
  }
  .el-dialog {
    width: 620px !important;
    margin-top: 20vh !important;
  }
  @media only screen and (max-width: 768px) {
    .el-dialog {
      width: calc(80% - 20px) !important;
    }
  }
  @media only screen and (max-width: 576px) {
    .el-dialog {
      width: calc(100% - 20px) !important;
    }
  }
}
</style>
